window.ShippingUtils = {

  wait(ms){
    return new Promise(
      resolve =>
        setTimeout(resolve, ms)
    );
  },

  async getCart(){

    const response =
      await fetch(
        '/cart.js',
        {
          cache:'no-store'
        }
      );

    return response.json();
  },

  async postJson(
    url,
    body,
    headers = {}
  ){

    return fetch(url, {
      method:'POST',
      headers:{
        'Content-Type':
          'application/json',
        ...headers
      },
      body:
        JSON.stringify(body)
    });

  },

  formatPrice(value){

    let price =
      Number(value);

    if(price > 999){
      price /= 100;
    }

    return price.toLocaleString(
      'pt-BR',
      {
        style:'currency',
        currency:'BRL'
      }
    );

  }

};